import { ShoppingBag } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useSettings } from "@/contexts/SettingsContext";

const MARKETPLACES = [
  { key: "shopee_url", label: "Shopee" },
  { key: "tokopedia_url", label: "Tokopedia" },
  { key: "tiktok_shop_url", label: "TikTok Shop" },
];

export const Marketplace = () => {
  const { settings } = useSettings();
  const items = MARKETPLACES.filter((m) => settings[m.key]);

  if (items.length === 0) return null;

  return (
    <section className="bg-cream-200 py-24 md:py-32 px-6 md:px-10">
      <div className="mx-auto max-w-7xl text-center">
        <Reveal>
          <Overline>Belanja Online</Overline>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-ink mb-12">
            Temukan kami di marketplace favorit Anda.
          </h2>
        </Reveal>
        <div className="flex flex-wrap justify-center gap-5">
          {items.map((m, i) => (
            <Reveal key={m.key} delay={i * 0.08}>
              <a
                href={settings[m.key]}
                target="_blank"
                rel="noreferrer"
                data-testid={`marketplace-${m.key}`}
                className="inline-flex items-center gap-3 rounded-full bg-cream border border-border/60 px-7 py-4 font-semibold text-ink hover:bg-honey hover:border-honey transition-colors duration-300"
              >
                <ShoppingBag size={20} />
                {m.label}
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
